'use strict';

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var Big = require('bignumber.js');

var CID = require('cids');

var _require = require('../../utils'),
    withTimeoutOption = _require.withTimeoutOption;

module.exports = function (_ref) {
  var bitswap = _ref.bitswap;
  return withTimeoutOption( /*#__PURE__*/function () {
    var _stat = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var snapshot;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              // eslint-disable-line require-await
              snapshot = bitswap.stat().snapshot;
              return _context.abrupt("return", {
                provideBufLen: parseInt(snapshot.providesBufferLength.toString()),
                blocksReceived: new Big(snapshot.blocksReceived),
                wantlist: Array.from(bitswap.getWantlist()).map(function (e) {
                  return e[1].cid;
                }),
                peers: bitswap.peers().map(function (id) {
                  return new CID(id.toB58String());
                }),
                dupBlksReceived: new Big(snapshot.dupBlksReceived),
                dupDataReceived: new Big(snapshot.dupDataReceived),
                dataReceived: new Big(snapshot.dataReceived),
                blocksSent: new Big(snapshot.blocksSent),
                dataSent: new Big(snapshot.dataSent)
              });

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    function stat() {
      return _stat.apply(this, arguments);
    }

    return stat;
  }());
};